import { module } from 'constant'
import { createSelector } from 'selectors'

const getOverlaySelector = (scope?: HTMLElement) =>
	createSelector({ scope, selector: module.overlay.selector.own }) as HTMLElement

export const getOverlay = () => getOverlaySelector()
